import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AuthGuard } from './shared/guards/auth.guard';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
    },
    {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent),
        canActivate: [MsalGuard, AuthGuard],
        data: { breadcrumb: 'Dashboard' },
    },
    {
        path: 'connectors',
        redirectTo: 'data-config',
        pathMatch: 'full',
    },
    {
        path: 'connectors/detail',
        loadComponent: () => import('./features/connectors/connector-detail/connector-detail.component').then(m => m.ConnectorDetailComponent),
        canActivate: [MsalGuard, AuthGuard],
        data: { breadcrumbs: [{ label: 'Data Configuration', url: '/data-config' }, { label: 'New Connector' }] },
    },
    {
        path: 'connectors/detail/:id',
        loadComponent: () => import('./features/connectors/connector-detail/connector-detail.component').then(m => m.ConnectorDetailComponent),
        canActivate: [MsalGuard, AuthGuard],
        data: { breadcrumbs: [{ label: 'Data Configuration', url: '/data-config' }, { label: 'Edit Connector' }] },
    },
    {
        path: 'data-config',
        loadComponent: () => import('./features/data-config/data-config.component').then(m => m.DataConfigComponent),
        canActivate: [MsalGuard, AuthGuard],
        data: { breadcrumb: 'Data Configuration' },
    },
    {
        path: 'mappings',
        redirectTo: 'data-config',
        pathMatch: 'full',
    },
    {
        path: 'mappings/detail',
        loadComponent: () => import('./features/mappings/mapping-detail/mapping-detail.component').then(m => m.MappingDetailComponent),
        canActivate: [MsalGuard, AuthGuard],
        data: { breadcrumbs: [{ label: 'Data Configuration', url: '/data-config' }, { label: 'New Mapping' }] },
    },
    {
        path: 'mappings/detail/:id',
        loadComponent: () => import('./features/mappings/mapping-detail/mapping-detail.component').then(m => m.MappingDetailComponent),
        canActivate: [MsalGuard, AuthGuard],
        data: { breadcrumbs: [{ label: 'Data Configuration', url: '/data-config' }, { label: 'Edit Mapping' }] },
    },
    {
        path: 'signals',
        redirectTo: 'data-config',
        pathMatch: 'full',
    },
    {
        path: 'signals/detail',
        loadComponent: () => import('./features/signals/signal-detail/signal-detail.component').then(m => m.SignalDetailComponent),
        canActivate: [MsalGuard, AuthGuard],
        data: { breadcrumbs: [{ label: 'Data Configuration', url: '/data-config' }, { label: 'New Signal' }] },
    },
    {
        path: 'signals/detail/:id',
        loadComponent: () => import('./features/signals/signal-detail/signal-detail.component').then(m => m.SignalDetailComponent),
        canActivate: [MsalGuard, AuthGuard],
        data: { breadcrumbs: [{ label: 'Data Configuration', url: '/data-config' }, { label: 'Edit Signal' }] },
    },
    {
        path: 'ai-insights',
        loadComponent: () => import('./features/ai-insights/ai-insights.component').then(m => m.AiInsightsComponent),
        canActivate: [MsalGuard, AuthGuard],
        data: { breadcrumb: 'AI Insights' },
    },
    {
        path: 'workflow',
        redirectTo: 'data-config',
        pathMatch: 'full',
    },
    {
        path: 'streams',
        redirectTo: 'data-config',
        pathMatch: 'full',
    },
    {
        path: 'audit-logs',
        loadComponent: () => import('./features/audit-logs/audit-logs.component').then(m => m.AuditLogsComponent),
        canActivate: [MsalGuard, AuthGuard],
        data: { breadcrumb: 'Audit Logs' },
    },
    {
        path: 'process-updates',
        loadComponent: () => import('./features/process-updates/process-updates.component').then(m => m.ProcessUpdatesComponent),
        canActivate: [MsalGuard, AuthGuard],
        data: { breadcrumb: 'Process Updates' },
    },
    {
        path: 'certificate-management',
        loadComponent: () => import('./features/certificate-management/certificate-management.component').then(m => m.CertificateManagementComponent),
        canActivate: [MsalGuard, AuthGuard],
        data: { breadcrumb: 'Certificate Management' },
    },
    {
        path: 'licensing',
        loadComponent: () => import('./features/licensing/licensing.component').then(m => m.LicensingComponent),
        canActivate: [MsalGuard, AuthGuard],
        data: { breadcrumb: 'Licensing' },
    },
    {
        path: 'profile',
        loadComponent: () => import('./features/profile/profile.component').then(m => m.ProfileComponent),
        canActivate: [MsalGuard, AuthGuard],
        data: { breadcrumb: 'Profile' },
    },
    {
        path: 'fleet',
        loadComponent: () => import('./features/fleet-management/fleet-management.component').then(m => m.FleetManagementComponent),
        canActivate: [MsalGuard, AuthGuard],
        data: { breadcrumb: 'Fleet' },
    },
    {
        path: 'fleet/device-groups',
        loadComponent: () => import('./features/fleet-management/fleet-management.component').then(m => m.FleetManagementComponent),
        canActivate: [MsalGuard, AuthGuard],
        data: { breadcrumbs: [{ label: 'Fleet', url: '/fleet' }, { label: 'Device Groups' }], fleetTab: 'device-groups' },
    },
    {
        path: 'fleet/connector-templates',
        loadComponent: () => import('./features/fleet-management/fleet-management.component').then(m => m.FleetManagementComponent),
        canActivate: [MsalGuard, AuthGuard],
        data: { breadcrumbs: [{ label: 'Fleet', url: '/fleet' }, { label: 'Connector Templates' }], fleetTab: 'connector-templates' },
    },
    {
        path: 'login-failed',
        loadComponent: () => import('./features/login-failed/login-failed.component').then(m => m.LoginFailedComponent),
    },
    {
        path: '**',
        redirectTo: 'dashboard'
    }
];
